export const getters = {
    getAtividadeCrmProposta: state => state.atividadeCrmProposta,
    getAtividadesCrmProposta: state => state.atividadesCrmProposta,
    getModalCadastroAtividadeCrmProposta: state => state.modalCadastroAtividadeCrmProposta,
    getModalExcluirAtividadeCrmProposta: state => state.modalExcluirAtividadeCrmProposta,
    getModalPesquisarAtividadeCrmProposta: state => state.modalPesquisarAtividadeCrmProposta,
}

export default {}